"use client" 
import Select from "react-select"
import CreatableSelect from 'react-select/creatable';
import makeAnimated from 'react-select/animated'
// import AsyncSelect from 'react-select/async';
import { useState, useEffect } from "react"
import axios from "axios"
import useSelectStyles from "./Styles";

const OrganizationSelect = ({onChange, value, placeholder, creatable}) => {

     const animatedComponents = makeAnimated();


     const [data, setData] = useState(null);
     const [loading, setLoading] = useState(true);
     const [error, setError] = useState(null);
     const [isClearable, setIsClearable] = useState(true);
     const [isSearchable, setIsSearchable] = useState(true);
     const [isDisabled, setIsDisabled] = useState(false);
     const [isLoading, setIsLoading] = useState(false);
     const [isRtl, setIsRtl] = useState(false);
     
     useEffect(() => {

          const getData = async () => {
               // Assume the environment variable is set correctly in your environment configuration
               const baseUrl = process.env.NODE_ENV === 'development' ? 'http://localhost:3000' : 'https://talnet.co';
               try {
                   const response = await fetch(`${baseUrl}/api/organizations`, {
                       method: 'GET',
                       headers: {
                           'Accept': '*/*',
                           'Content-Type': 'application/json'
                       },
                       credentials: 'include', // Necessary for cookies if API is on the same domain
                   });
                   if (!response.ok) {
                       throw new Error('Network response was not ok');
                   }
                   const data = await response.json();

                   let arr = []
                   data.data.forEach(org => {
                        let obj = {id: org.id, location:org.location, value: org.organization_name, label: org.organization_name, name: org.organization_name, organization_uuid: org.organization_uuid}
                        arr.push(obj)
                   });
                   setData(arr);
                  //  console.log("XARRAY", arr)

                  //  console.log("DATA@admin/page.js", data); // Log to see what the data looks like
               } catch (error) {
                   console.error('Failed to fetch jobs:', error);
               }
              }

     const getX = async () => {
          try {

          const response = await axios.get(`/api/organizations/`);

          let data = response.data;

          let array = []
          data.forEach(company => {
               let obj = {id: company.id, location:company.location, value: company.company_name, label: company.company_name, name: company.name, company_uuid: company.company_uuid}
               array.push(obj)
          });

          setData(array);
          setError(null);
          return data
          } catch(error) {
          setError(error.message);
          setData(null);
          } finally {
          setLoading(false);
          }  
     }
     getData()
     }, [])

     return (
          <>
          {creatable ? 
          <CreatableSelect
          className="w-full dark:bg-inherit appearance-none inner-shadow rounded px-0 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
          classNamePrefix="select"
        //   defaultValue={colourOptions[0]}
          isDisabled={isDisabled}
          isLoading={isLoading}
          isClearable={isClearable}
          isRtl={isRtl}
          isSearchable={isSearchable}
          name="currentCompany"
          id="currentCompany"
          onChange={onChange}
          value={value}
          options={data}
          // components={animatedComponents}
          placeholder={placeholder}
          styles={useSelectStyles()}
          // closeMenuOnSelect={false}
          // defaultValue={[data]}
        />
        :
          <Select
            className="w-full dark:bg-inherit appearance-none inner-shadow rounded px-0 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
            classNamePrefix="select"
          //   defaultValue={colourOptions[0]}
            isDisabled={isDisabled}
            isLoading={isLoading}
            isClearable={isClearable}
            isRtl={isRtl}
            isSearchable={isSearchable}
            name="currentCompany"
            id="currentCompany"
            onChange={onChange}
            value={value}
            options={data}
            // components={animatedComponents}
            placeholder={placeholder}
            styles={useSelectStyles()}
            // closeMenuOnSelect={false}
            // defaultValue={[data]}
          />}
    
    
     {/*
          <div
            style={{
              color: 'hsl(0, 0%, 40%)',
              display: 'inline-block',
              fontSize: 12,
              fontStyle: 'italic',
              marginTop: '1em',
            }}
          >
            <Checkbox
              checked={isClearable}
              onChange={() => setIsClearable((state) => !state)}
            >
              Clearable
            </Checkbox>
            <Checkbox
              checked={isSearchable}
              onChange={() => setIsSearchable((state) => !state)}
            >
              Searchable
            </Checkbox>
            <Checkbox
              checked={isDisabled}
              onChange={() => setIsDisabled((state) => !state)}
            >
              Disabled
            </Checkbox>
            <Checkbox
              checked={isLoading}
              onChange={() => setIsLoading((state) => !state)}
            >
              Loading
            </Checkbox>
            <Checkbox checked={isRtl} onChange={() => setIsRtl((state) => !state)}>
              RTL
            </Checkbox> 
          </div>
          */}
        </>
     //      <>

     // <Select className="w-full mb-4 shadow appearance-none border rounded py-2 px-3 mx-5 text-gray-700 leading-tight focus:outline-none focus:shadow-outline place-items-start"
     // closeMenuOnSelect={false}
     // components={animatedComponents}
     // // defaultValue={[options[4], options[5]]}
     // isMulti
     // options={data}
     // />
     // </>
     )
}

export default OrganizationSelect